<template>
    <span>{{ attribute }}</span>
</template>

<script>
import stringFormatting from '@/mixins/stringFormatting'

export default {
    mixins: [stringFormatting],

    props: ['row'],

    data() {
        return {
            attribute: this.row.attribute || `${this.row.model_count} ${this.pluralize(this.row.model_name)}`,
        }
    },
}
</script>
